import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import cn from 'classnames';
import styles from './Checkbox.module.css';

export type Props = JSX.IntrinsicElements['input'] & {
  form: any;
  name: string;
  label?: string;
  onClick?: VoidFunction;
  disabled?: boolean;
  labelClassName?: string;
  checkboxClassName?: string;
};

const Checkbox = forwardRef<HTMLInputElement, Props>((props, forwardedRef) => {
  const {
    form,
    name,
    label,
    className,
    onClick,
    labelClassName,
    checkboxClassName,
    ...restOfProps
  } = props;

  return (
    <Controller
      control={form.control}
      name={name}
      render={({ field }) => {
        const onChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
          field.onChange(event.target.checked);
        };

        return (
          <label className={cn(styles.checkbox, checkboxClassName)} onClick={onClick}>
            <input
              type={'checkbox'}
              ref={forwardedRef}
              className={styles.checkbox__input}
              checked={field.value}
              onChange={onChangeInput}
              {...restOfProps}
            />
            <span className={cn(styles.checkbox__element, className)} />
            {label && (
              <span className={cn(styles.checkbox__label, labelClassName)}>{label}</span>
            )}
          </label>
        );
      }}
    />
  );
});

export default Checkbox;
